import { cn } from '@/utils/tailwind-util';

import { Button } from '@/components/Button';

import { useStaticDropdownAction } from '../states/useStaticDropdown';

interface Props {
  title?: string;
  children: React.ReactNode;
  buttons?: [
    { label: string; action: () => void | null; close: boolean } | null,
    { label: string; action: () => void | null; close: boolean } | null
  ];
}

const DropdownTemplate: React.FC<Props> = ({
  title,
  children,
  buttons = [null, { label: '확인', action: null, close: true }],
}) => {
  const { onToggleDropdown } = useStaticDropdownAction();

  return (
    <div className="px-8 pt-8 pb-6 min-w-[320px]">
      {title && <div className="font-semibold mb-2">{title}</div>}
      {children}
      <div className="w-full flex justify-end mt-14">
        {buttons.map((button, index) => {
          if (button) {
            return (
              <Button
                key={`button-${index}`}
                variant={index === 0 ? 'ghost' : 'solid'}
                styles={'mr-2'}
                onClick={() => {
                  button?.close && onToggleDropdown(); // dropdown closing
                  button?.action && button?.action(); // callback
                }}
              >
                {button.label}
              </Button>
            );
          }
        })}
      </div>
    </div>
  );
};

export default DropdownTemplate;
